<template>
  <div></div>
</template>

<script>
import GlobalConfig from "@/assets/js/config/global";
import { ApiMethods } from "@/assets/js/http-serve/http-methods";
import { loginOrRefresh } from "../../assets/js/http-serve/corp/common";
import { isInDingTalk } from "../../assets/js/utils/ding-env";

let base64 = require("js-base64").Base64;

export default {
  data () {
    return {};
  },
  methods: {
    urlDecode: function (url) {
      while (
        url.startsWith("http%") ||
        url.startsWith("https%") ||
        url.startsWith("%")
      ) {
        url = window.decodeURIComponent(url);
      }
      return url;
    },
    /** 获取目标页面路由路径，默认/viewIndex */
    getAccessPage () {
      var defaultIndex = "/viewIndex";
      if (this.$route.query.ap) {
        var path = this.urlDecode(this.$route.query.ap);
        if (path == "/" || path == "") {
          return defaultIndex;
        } else {
          return path;
        }
      } else {
        return defaultIndex;
      }
    },
    /** 设置token */
    setCookieToken (result, clear) {
      var _this = this;
      _this.$store.dispatch("setSyncStatus", true);
      if (isInDingTalk) {
        localStorage.setItem("loginUser", JSON.stringify(result.data));
      }
      const jsonToken = _this.$jzqCookie.getTokenJson();
      if (result.success && result.data && result.data.token) {
        jsonToken.ut = result.data.token;
        var token = base64.encode(JSON.stringify(jsonToken));
        _this.$store.dispatch("setAuthToken", token);
        _this.$jzqCookie.setToken(token);
        return true;
      } else if (clear) {
        _this.$store.dispatch("setAuthToken", null);
        _this.$jzqCookie.removeToken();
      }
      return false;
    },
    async goAccountAuth () {
      var _this = this;
      var path = _this.getAccessPage();
      const authType = _this.$route.query.authType; // 0不需要登录 1需要登录 2 url权限 3子账号登录
      if (authType == 1) {
        //跳转账户中心判断登录状态，登录则跳转cp设置cookie,没有登录跳转lp
        var ap = encodeURIComponent(path); //访问页面
        var cp = encodeURIComponent(
          GlobalConfig.domain.junziqianWebOp + "/login/authorize"
        ); //授权设置cookie页面
        var lp = encodeURIComponent(
          GlobalConfig.domain.junziqianWebOp + "/login"
        ); //登录页面
        if (isInDingTalk) {
          const corpId = sessionStorage.getItem("corpId");
          location.href = `${GlobalConfig.domain.junziqianWebOp}/login/middle?corpId=${corpId}`
        } else {
          window.location.href =
            GlobalConfig.domain.accountWeb +
            "/login/authorization?ap=" +
            ap +
            "&cp=" +
            cp +
            "&lp=" +
            lp;
        }
      } else {
        //这种有可能因跨域拿不到登录信息但这些页面本身不需要登录
        // _this.$loading();
        var result = await ApiMethods.AccountLoginController.syncLogin();
        // _this.$loading().close();
        _this.setCookieToken(result, false);
        // 这里调用 loginOrRefresh 是因为处理：验证码登录情况下，某些请求在设置token之前被调用，导致没有信息   --25/02/19
        await loginOrRefresh();
        console.log("1path=>" + path);
        if (path.startsWith("http")) {
          isInDingTalk ? location.href = path : window.location.href = path;
        } else {
          await _this.$router.push({ path: path }, () => { }, () => { });
        }
      }
    },
    doSyncLogin: async function () {
      let _this = this;
      if (_this.$route.query.t) {
        _this.$jzqCookie.set("jtoken", _this.$route.query.t);
      }
      var jtoken = _this.$jzqCookie.get("jtoken");
      // console.log("jtoken", jtoken);
      if (!jtoken) {
        //没有cookie去授权
        await _this.goAccountAuth();
      } else {
        // 有token先校验token, 校验失效去登录认证
        // _this.$loading();
        let result = await ApiMethods.AccountLoginController.ssoTkCheck({
          t: jtoken
        });
        // _this.$loading().close();
        if (_this.setCookieToken(result, true)) {
          //cookie有效
          try {
            await loginOrRefresh(); //获取所有用户信息，并设置默认选中账号
          } catch (e) {
            console.log(e);
          }
          let path = _this.getAccessPage();
          console.log("2path=>" + path);
          if (path.startsWith("http")) {
            window.location.href = path;
          } else {
            await _this.$router.push({ path: path });
          }
        } else {
          //cookie失效
          await _this.goAccountAuth();
        }
      }
    }
  },
  mounted () {
    this.doSyncLogin();
  },
  name: "authorize",
  layout: "empty"
};
</script>



// WEBPACK FOOTER //
// pages/login/authorize.vue